import React, { useEffect, useState } from 'react'
import { WPSingleJobItem } from '../../typings';
import * as styles from './Header.module.scss';
import frogLogo from '../../images/frog.png';
import capgeminiLogo from '../../images/capgeminiBlue.png';
import capgeminiEngineeringLogo from '../../images/Logo_Capgemini_Engineering_new.png';
import capgeminiInventLogo from '../../images/Logo_Capgemini_Invent_new.png';
import sogetiLogo from '../../images/sogeti.png';

const { __ } = window.wp.i18n;

interface HeaderProps {
  singleJob: WPSingleJobItem;
}
type FilterTypes = 'ref' | 'department' | 'country_code' | 'experience_level' | 'sbu' | 'location' | 'brand' | 'professional_communities' | 'contract_type' | 'education_level';
// get the filters selected in settings
interface Window {
  cg_jobs_singlejob_desc_setting?: FilterTypes[];
  cg_jobs_translated_filters?: { string: { string: string } };
}
const selectedTags = (window as Window).cg_jobs_singlejob_desc_setting as FilterTypes[];

export const Header: React.FC<HeaderProps> = ({ singleJob }) => {
  const [fixedHeader, setFixedHeader] = useState(false)
  const OpenSocialModal = () => {
    // const filters = document.querySelector('.open-filters') as HTMLElement;
    // filters ? filters.style.display = "block" : ""
  }

  const stickyElem = document.querySelector("#sticky-header") as HTMLElement;
  const currStickyPos = stickyElem && (stickyElem.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop));

  window.onscroll = function () {
    if (((window.pageYOffset || document.documentElement.scrollTop) > currStickyPos) && window.matchMedia("(min-width: 992px)").matches) {
      setFixedHeader(true);
    } else {
      setFixedHeader(false);
    }
  }

  let brandLogo;
  switch (singleJob.brand) {
    case "Capgemini":
      brandLogo = capgeminiLogo;
      break;
    case "Capgemini Engineering":
      brandLogo = capgeminiEngineeringLogo;
      break;
    case "Capgemini Invent":
      brandLogo = capgeminiInventLogo;
      break;
    case "Sogeti":
      brandLogo = sogetiLogo;
      break;
    case "frog":
      brandLogo = frogLogo;
      break;
    default:
      brandLogo = "";
  }

  function updateLabel(label: string, filterType: string) {
    const cg_jobs_translated_filters = (window as Window).cg_jobs_translated_filters;
    // Split the label into an array if it contains commas
    const labels = label?.split(',');

    // Translate each value and join them back into a comma-separated string
    const translatedLabels = labels?.map((singleLabel) => {
      const trimmedLabel = singleLabel?.trim(); // Remove extra spaces
      if (
        cg_jobs_translated_filters &&
        filterType in cg_jobs_translated_filters &&
        encodeURIComponent(trimmedLabel) in cg_jobs_translated_filters[filterType] &&
        cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)] !== ''
      ) {
        return cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)];
      }
      return trimmedLabel; // Return original label if no translation is found
    });

    return translatedLabels?.join(', '); // Join the translated labels back into a string
  }
  
  return (
    <div className={styles['header']}>
      <div className={styles['mobile-header']}>
        <button type='button' className={styles['back-btn']} onClick={() => { window.history.back(); return false; }}>
          {/*<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 0.953125L1 8.45312L8.39412 15.9531" stroke="var(--zodiak-text-primary)" stroke-width="1.76471" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>*/}
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none">
            <path d="M8.25 15.4531L1.25 8.45312L8.25 1.45312" stroke="var(--zodiak-text-primary)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>{__('Back', 'cg-jobs')}
        </button>
        <div>
          <a href={singleJob?.apply_job_url} className={[styles['apply'], 'cta-link'].join(" ")} target="_blank">{__('Apply', 'cg-jobs')}</a>
          <button type='button' data-bs-toggle="modal" data-bs-target="#socialMediaModal" aria-controls="socialMediaModal" className={styles['open-social-modal']} aria-label="Share this page with yourself or people you know">
            {/*<svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.8333 17.4892C17.9044 17.4892 17.0733 17.8558 16.4378 18.4303L7.72333 13.3581C7.78444 13.0769 7.83333 12.7958 7.83333 12.5025C7.83333 12.2092 7.78444 11.9281 7.72333 11.6469L16.34 6.62361C17 7.23472 17.8678 7.61361 18.8333 7.61361C20.8622 7.61361 22.5 5.97583 22.5 3.94694C22.5 1.91805 20.8622 0.280273 18.8333 0.280273C16.8044 0.280273 15.1667 1.91805 15.1667 3.94694C15.1667 4.24027 15.2156 4.52138 15.2767 4.8025L6.66 9.82583C6 9.21472 5.13222 8.83583 4.16667 8.83583C2.13778 8.83583 0.5 10.4736 0.5 12.5025C0.5 14.5314 2.13778 16.1692 4.16667 16.1692C5.13222 16.1692 6 15.7903 6.66 15.1792L15.3622 20.2636C15.3011 20.5203 15.2644 20.7892 15.2644 21.0581C15.2644 23.0258 16.8656 24.6269 18.8333 24.6269C20.8011 24.6269 22.4022 23.0258 22.4022 21.0581C22.4022 19.0903 20.8011 17.4892 18.8333 17.4892ZM18.8333 2.72472C19.5056 2.72472 20.0556 3.27472 20.0556 3.94694C20.0556 4.61916 19.5056 5.16916 18.8333 5.16916C18.1611 5.16916 17.6111 4.61916 17.6111 3.94694C17.6111 3.27472 18.1611 2.72472 18.8333 2.72472ZM4.16667 13.7247C3.49444 13.7247 2.94444 13.1747 2.94444 12.5025C2.94444 11.8303 3.49444 11.2803 4.16667 11.2803C4.83889 11.2803 5.38889 11.8303 5.38889 12.5025C5.38889 13.1747 4.83889 13.7247 4.16667 13.7247ZM18.8333 22.3047C18.1611 22.3047 17.6111 21.7547 17.6111 21.0825C17.6111 20.4103 18.1611 19.8603 18.8333 19.8603C19.5056 19.8603 20.0556 20.4103 20.0556 21.0825C20.0556 21.7547 19.5056 22.3047 18.8333 22.3047Z" fill="var(--zodiak-text-primary)" />
            </svg>*/}
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
              <path d="M12.25 18L20.25 22M20.25 10L12.25 14M24.25 28C22.0409 28 20.25 26.2091 20.25 24C20.25 21.7909 22.0409 20 24.25 20C26.4591 20 28.25 21.7909 28.25 24C28.25 26.2091 26.4591 28 24.25 28ZM8.25 20C6.04086 20 4.25 18.2091 4.25 16C4.25 13.7909 6.04086 12 8.25 12C10.4591 12 12.25 13.7909 12.25 16C12.25 18.2091 10.4591 20 8.25 20ZM24.25 12C22.0409 12 20.25 10.2091 20.25 8C20.25 5.79086 22.0409 4 24.25 4C26.4591 4 28.25 5.79086 28.25 8C28.25 10.2091 26.4591 12 24.25 12Z" stroke="var(--zodiak-text-primary)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      {(singleJob?.brand && singleJob?.brand !== 'others') && <div className={[styles['only-mobile'], 'container'].join(' ')}>
        <div className={`${styles["brand-logo"]} ${singleJob?.brand?.replace(/\s+/g, '-').toLowerCase()}`}>
          <img
            src={brandLogo}
            alt={singleJob?.brand}
          />
        </div>
      </div>}
      <div className={[styles['header-top-wrapper'], fixedHeader ? styles["fixed"] : ""].join(" ")} id="sticky-header">
        <div className={[styles['header-top'], 'container'].join(" ")}>
          <div>
            <h1>{singleJob?.title}</h1>
            <p className={styles['job-location']}>{updateLabel(singleJob?.location, 'location')}</p>
          </div>
          <a href={singleJob?.apply_job_url} className={[styles['apply'], 'cta-link'].join(" ")} target="_blank">{__('Apply for this job', 'cg-jobs')}</a>
        </div>
      </div>
      {!fixedHeader && (<div className={styles['header-bottom']}>
        <div className={[styles['features'], 'container'].join(' ')}>
          <ul>
            {selectedTags && selectedTags.map((tag) => {
              if (tag !== "brand") {
                const key = tag as string === 'ref_code' ? 'ref' : tag;

                return (singleJob[key]) ? (
                  <li key={key} className={styles[key]}>{key === "ref" ? ('ID ' + singleJob[key]) : updateLabel(singleJob[key], key)}</li>
                ) : null
              }
            })}
          </ul>
          {(selectedTags.includes('brand') && singleJob?.brand && singleJob?.brand !== 'others') && <div className={styles['only-desktop']}>
            <div className={`${styles["brand-logo"]} ${singleJob?.brand?.replace(/\s+/g, '-').toLowerCase()}`}>
              <img
                src={brandLogo}
                alt={singleJob?.brand}
              />
            </div>
          </div>}
        </div>
      </div>)}
      {(selectedTags.includes('brand') && singleJob?.brand && singleJob?.brand !== 'others') && <div className={[styles['only-tablet'], 'container'].join(" ")}>
        <div className={`${styles["brand-logo"]} ${singleJob?.brand?.replace(/\s+/g, '-').toLowerCase()}`}>
          <img
            src={brandLogo}
            alt={singleJob?.brand}
          />
        </div>
      </div>}
    </div>
  )
}